import COLORS from '@/constants/colors';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { AlertColor } from '@mui/material';
import { JSX } from 'react';

export interface SnackbarUi {
  message: string;
  type: AlertColor;
  backgroundColor: string;
  icon?: boolean | JSX.Element;
  borderColor: string;
  color: string;
  open: boolean;
  autoHideDuration?: number;
}

export function getSnackbarUi(args: {
  type: AlertColor;
  message: string;
  open: boolean;
  autoHideDuration?: number;
}): SnackbarUi {
  switch (args.type) {
    case 'success':
      return {
        backgroundColor: COLORS.foam,
        type: args.type,
        icon: (
          <CheckCircleIcon
            fontSize="inherit"
            sx={{ color: COLORS.sageGreen }}
          />
        ),
        borderColor: COLORS.neptune,
        color: COLORS.deep_sea,
        message: args.message,
        open: args.open,
        autoHideDuration: args.autoHideDuration,
      };
    case 'error':
      return {
        type: args.type,
        backgroundColor: COLORS.light_red,
        icon: (
          <DoNotDisturbIcon
            sx={{ color: COLORS.helperText_red, fontSize: '21px' }}
          />
        ),
        borderColor: COLORS.smoky_topaz,
        color: COLORS.helperText_red,
        message: args.message,
        open: args.open,
        autoHideDuration: args.autoHideDuration,
      };
    case 'warning':
      return {
        type: args.type,
        backgroundColor: COLORS.champagne,
        icon: <WarningAmberRoundedIcon sx={{ color: COLORS.chelsea_gem }} />,
        borderColor: COLORS.chelsea_gem,
        color: COLORS.chelsea_gem,
        message: args.message,
        open: args.open,
        autoHideDuration: args.autoHideDuration,
      };
    case 'info':
      return {
        type: args.type,
        backgroundColor: COLORS.link_water,
        icon: <CheckIcon fontSize="inherit" sx={{ color: COLORS.smalt }} />,
        borderColor: COLORS.smalt,
        color: COLORS.smalt,
        message: args.message,
        open: args.open,
        autoHideDuration: args.autoHideDuration,
      };
  }
}

export const initialState: SnackbarUi = {
  type: 'error',
  message: '',
  backgroundColor: '',
  borderColor: '',
  color: '',
  open: false,
};
